import React, { useState } from "react";

import { Link, useHistory, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import detailPageLogo from './../assets/imgs/logos/new_stad_gemeente-logo.png'
import Icon from "@identitybuilding/idb-react-iconlib";
import "../assets/css/Navigation.css";
import { toggleLoginScreen } from "../actions/AccountAction";
import { useEffect } from "react";
import { getEnvironmentConfig } from "../utils/functions";
const Navigation = (props) => {
  const [networks, setNetworks] = useState(false);

  const lang = useSelector((state) => state.general.lang);
  const translate = useSelector((state) => state.general.translate);
  const { loginScreen, accountData } = useSelector((state) => state.account);
  const dispatch = useDispatch();
  const history = useHistory();
  const urlConfig = getEnvironmentConfig()
  // const LogoSA = require("../assets/imgs/logos/logo_shoppaworld.svg");
  // const LogoSA_Invert = require("../assets/imgs/logos/logo_shoppaworld-invert.svg");
  useEffect(() => {}, [loginScreen, accountData]);
  const LogoSA = require(`../assets/imgs/logos/logo_shoppaworld.svg`).default;
  const LogoSA_Invert =
    require("../assets/imgs/logos/logo_shoppaworld-invert.svg").default;
  const LogoPN = require(`../assets/imgs/logos/pn/logo_pn_${lang}.svg`);
  const LogoPN_Invert = require(`../assets/imgs/logos/pn/logo_pn_invert_${lang}.svg`);
  const LogoCN = require(`../assets/imgs/logos/cn/logo_cn_${lang}.svg`);
  const LogoCN_Invert = require(`../assets/imgs/logos/cn/logo_cn_invert_${lang}.svg`);
  const LogoESN = require(`../assets/imgs/logos/esn/logo_esn_${lang}.svg`);
  const LogoESN_Invert = require(`../assets/imgs/logos/esn/logo_esn_invert_${lang}.svg`);
  const LogoPL = require(`../assets/imgs/logos/pl/logo_pl_${lang}.svg`);
  const LogoPL_Invert = require(`../assets/imgs/logos/pl/logo_pl_invert_${lang}.svg`);
  const followState = useSelector((state) => state.account.followState); // Access followState from Redux store
  // Define dynamic routes based on the site's language
  const routeMap = {
    nl: { collaboration: "/actieve-gemeenten", following: "/wie-volg-ik", accountSettings: "/account-instellingen", preferences: "/voorkeuren" },
    fr: { collaboration: "/communes-actives", following: "/mes-suivis", accountSettings: "/parametres-du-compte", preferences: "/mes-preferences" },
    en: { collaboration: "/active-municipalities", following: "/who-i-follow", accountSettings: "/account-settings", preferences: "/my-preferences" },
    de: { collaboration: "/aktive-gemeinden", following: "/wer-folge-ich", accountSettings: "/kontoeinstellungen", preferences: "/einstellungen" },
  };
  const routePath_HasCollaboration = routeMap[lang]?.collaboration || routeMap.nl.collaboration;
  const routePath_Following = routeMap[lang]?.following || routeMap.nl.following;
  const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
  const location = useLocation();

  // To toggle the colour of the nav buttons
  const allCollaborationPaths = Object.values(routeMap).map(r => r.collaboration);
  const allFollowingPaths = Object.values(routeMap).map(r => r.following);
  const isHasCollaborationPage = allCollaborationPaths.some(p => window.location.href.includes(p));
  const is_FollowingMunicipalitiesPage = allFollowingPaths.some(p => window.location.href.includes(p));

  let networkFunction = "";
  const isAllowedUrlForNotShowingTheActiveColour = () => {
    const domainHosts = ["localhost", "mijn.stad-gemeente.be", "ma.ville-commune.be", "city-municipality.be", "stadt-gemeinde.be"];
    const allowedPaths = ["/", routePath_HasCollaboration, routePath_Following];
    const allowedUrls = domainHosts.flatMap(hostname =>
      allowedPaths.map(pathname => ({ hostname, pathname }))
    );

    return allowedUrls.some(
      (url) =>
        window.location.hostname === url.hostname &&
        window.location.pathname === url.pathname
    );
  };

  let path = window.location.pathname;
  const LogoutHandler = () => {
    localStorage.removeItem("StadGemeenteToken");
    dispatch({ type: "TOGGLE_LOGGED_IN_STATE", value: false });
    dispatch({ type: "TOGGLE_FOLLOW_STATE", value: false });
    history.push(routePath_HasCollaboration);
    window.location.reload(true);
  };

  const timeoutFunction = () => {
    networkFunction = setTimeout(() => {
      setNetworks(false);
    }, 5000);
  };

  return (
    <nav
      className={networks ? "active" : ""}
      id={props.Zindex ? "active" : ""}
      onMouseLeave={() => networks && timeoutFunction()}
      onMouseOverCapture={() => networks && clearTimeout(networkFunction)}
      style={{
        boxShadow: props.background ? "0 0 10px rgba(0,0,0,.1)" : "none",
      }}
    >
      {/* Networks navigation */}
      <div className="networks">
        <a
          className="osn networkLogo"
          href={
            lang === "fr"
              ? `https://${urlConfig['100_POURCENT_DOMAIN_URL'] || '100pourcentlocale.be'}`
              : `https://${urlConfig.DOMAIN_URL || '100procentlokaal.be'}`
          }
          rel="noopener noreferrer"
          target="_blank"
        >
          <img className="logo" src={LogoPL_Invert} alt={translate("pl_alt")} />
          <img
            className="logo logoOriginal"
            src={LogoPL}
            alt={translate("pl_alt")}
          />
        </a>
        <a
          className="osn networkLogo"
          href={
            lang === "fr"
              ? `https://${urlConfig.RESEAUENTREPRENEURS_DOMAIN_URL || 'reseauentrepreneurs.be'}`
              : `https://${urlConfig.ONDERNEMERSNETWERK_DOMAIN_URL || 'ondernemersnetwerk.be'}`
          }
          rel="noopener noreferrer"
          target="_blank"
        >
          <img
            className="logo"
            src={LogoESN_Invert}
            alt={translate("esn_alt")}
          />
          <img
            className="logo logoOriginal"
            src={LogoESN}
            alt={translate("esn_alt")}
          />
        </a>
        <a
          className="cn networkLogo"
          href={`${urlConfig.CATALOGOUS_DOMAIN_URL ? `https://${urlConfig.CATALOGOUS_DOMAIN_URL}` : "https://catalogusnetwerk.be"}`}
          rel="noopener noreferrer"
          target="_blank"
        >
          <img className="logo" src={LogoCN_Invert} alt={translate("cn_alt")} />
          <img
            className="logo logoOriginal"
            src={LogoCN}
            alt={translate("cn_alt")}
          />
        </a>
        <a
          className="pn networkLogo"
          href={`${urlConfig.PROMONETWERK_DOMAIN_URL ? `https://${urlConfig.PROMONETWERK_DOMAIN_URL}` : "https://promonetwerk.be"}`}
          rel="noopener noreferrer"
          target="_blank"
        >
          <img className="logo" src={LogoPN_Invert} alt={translate("pn_alt")} />
          <img
            className="logo logoOriginal"
            src={LogoPN}
            alt={translate("pn_alt")}
          />
        </a>
        <a
          className="sa networkLogo"
          href="https://shoppa.world"
          rel="noopener noreferrer"
          target="_blank"
        >
          <img src={LogoSA_Invert} className="logo" alt="Logo ShoppA.world" />
          <img
            className="logo logoOriginal"
            src={LogoSA}
            alt="Logo ShoppA.world"
          />
        </a>
      </div>

      {/* Navigation menu */}
      <div className="nav_menu">
        {/* Navigation logo */}
        <div className="" style={{ width: '300px'}}>
          <Link className="navLogo" to="/">
          {/* <img
            height="25px"
            width="25px"
            alt={translate("esn_alt")}
            className="logo logoOriginal"
            src={detailPageLogo}
            // src={
            //   "https://zappa-tlaqv351d.s3.amazonaws.com/media/brand/l/mijn_stad-gemeente.png"
            // }
          /> */}
          <img
            height="45px"
            width="45px"
            alt={`logo of my ${props.type}`}
            className={`logo logoOriginal ${props.type} ${lang} ${props.type === "city" ? 'stad' : 'gemeente'}`}
            src={
              props.type === "city"
              ? require(`../assets/imgs/logos/mijn-stad_horizontaal_green_${lang}.svg`)
              : require(`../assets/imgs/logos/mijn-gemeente_horizontaal_green_${lang}.svg`)
            }
          />
        </Link>
        </div>
        
        <div className="wrap_header_content">
          <div className={`stad_header_main_div stad_header_news_text_${lang}`}>
            <div className={`header_ticker_wrapper ${((props.recentRegistrations && props.recentRegistrations.length > 0) || (props.recentPublications && props.recentPublications.length > 0)) ? 'has_registrations' : ''}`}>
              <span className="header_ticker_content">
                <span className="stad_header_news_text">
                  {translate('stad_gemeente_header_center_text_1')}{' '}
                  <span className="highlight_header_text">{translate('stad_gemeente_header_center_text_2')}</span>{' '}
                  {translate('stad_gemeente_header_center_text_3')}{' '}
                  <span className="highlight_header_text">{translate('stad_gemeente_header_center_text_4')}</span>
                  <span>{lang === 'nl' ? `!` : ` !`}</span>
                </span>
                {((props.recentRegistrations && props.recentRegistrations.length > 0) || (props.recentPublications && props.recentPublications.length > 0)) && (
                  <span className="header_ticker_registrations">
                    {(props.recentRegistrations || []).map((reg, i) => {
                      const parts = [
                        ...(reg.municipalities || (reg.municipality ? [reg.municipality] : [])),
                        ...(reg.provinces || []).map(p => `${translate('province_of')} ${p}`)
                      ];
                      if (parts.length === 0) return null;
                      return (
                        <span key={`reg-${i}`} className="header_ticker_item">
                          {' \u00A0\u00A0\u00A0 '}
                          {translate('new_registration_for')} {parts.join(', ')}
                        </span>
                      );
                    })}
                    {(props.recentPublications || []).map((pub, i) => {
                      if (!pub.brand || !pub.municipalities || pub.municipalities.length === 0) return null;
                      return (
                        <span key={`pub-${i}`} className="header_ticker_item">
                          {' \u00A0\u00A0\u00A0 '}
                          {translate('new_edition_of')} {pub.brand} {translate('in_municipalities')} {pub.municipalities.join(', ')}
                        </span>
                      );
                    })}
                  </span>
                )}
              </span>
              {((props.recentRegistrations && props.recentRegistrations.length > 0) || (props.recentPublications && props.recentPublications.length > 0)) && (
                <span className="header_ticker_content header_ticker_duplicate" aria-hidden="true">
                  <span className="stad_header_news_text">
                    {translate('stad_gemeente_header_center_text_1')}{' '}
                    <span className="highlight_header_text">{translate('stad_gemeente_header_center_text_2')}</span>{' '}
                    {translate('stad_gemeente_header_center_text_3')}{' '}
                    <span className="highlight_header_text">{translate('stad_gemeente_header_center_text_4')}</span>
                    <span>{lang === 'nl' ? `!` : ` !`}</span>
                  </span>
                  <span className="header_ticker_registrations">
                    {(props.recentRegistrations || []).map((reg, i) => {
                      const parts = [
                        ...(reg.municipalities || (reg.municipality ? [reg.municipality] : [])),
                        ...(reg.provinces || []).map(p => `${translate('province_of')} ${p}`)
                      ];
                      if (parts.length === 0) return null;
                      return (
                        <span key={`reg-${i}`} className="header_ticker_item">
                          {' \u00A0\u00A0\u00A0 '}
                          {translate('new_registration_for')} {parts.join(', ')}
                        </span>
                      );
                    })}
                    {(props.recentPublications || []).map((pub, i) => {
                      if (!pub.brand || !pub.municipalities || pub.municipalities.length === 0) return null;
                      return (
                        <span key={`pub-${i}`} className="header_ticker_item">
                          {' \u00A0\u00A0\u00A0 '}
                          {translate('new_edition_of')} {pub.brand} {translate('in_municipalities')} {pub.municipalities.join(', ')}
                        </span>
                      );
                    })}
                  </span>
                </span>
              )}
            </div>
          </div>
          
          {/* Navigation menu items */}
          <div className="nav_buttons"
            // style={{ width: '30%' }}
          >
            {accountData ? (
              <>
                <button
                  className={`nav_buttons_navigate ${
                    isHasCollaborationPage ? "nav_buttons_navigate_active" : ""
                  }`}
                  onClick={() => {
                    history.push(routePath_HasCollaboration);
                    dispatch({ type: "TOGGLE_FOLLOW_STATE", value: false });
                  }}
                  title={translate("active_gemeenten_tooltip")}
                >
                  {translate("ACTIEVE_GEMEENTEN")}
                </button>
                <button
                  className={`nav_buttons_navigate_muni ${
                    is_FollowingMunicipalitiesPage
                      ? "nav_buttons_navigate_active_muni"
                      : ""
                  }`}
                  onClick={() => {
                    dispatch({ type: "TOGGLE_FOLLOW_STATE", value: true });
                    history.push(routePath_Following);
                  }}
                  title={translate("who_i_follow_tooltip")}
                >
                  {translate("who_i_follow")}
                </button>
              </>
            ) : null}
            {/* Button to open the networks menu */}
            {/* <a
              className="nav_button my_company"
              // href={`https://${lang === "fr" ? "modifie.be" : "wijzig.be"}`}
              rel="noreferrer noopener"
              target="_blank"
            >
              {translate("log_in")}
            </a> */}
            <div
              className={`nav_button network ${networks ? "active" : ""}`}
              onClick={() => setNetworks(!networks)}
            >
              {translate("networks")}
            </div>
            {accountData ? (
              <div className="account_button">
                <div className="nav_button my_company account_name">
                  {accountData.email}
                </div>
                <div className="account_options">
                  <div className="account_options_item">
                    <figure>
                      <img
                        src={accountData.image || require("../assets/imgs/logo_placeholder.png")}
                        alt={accountData.image ? accountData.email : "placeholder"}
                        onError={(e) => {
                          e.target.src = require("../assets/imgs/logo_placeholder.png");
                        }}
                      />
                    </figure>
                    <div style={{ textOverflow: "ellipsis", overflow: "hidden" }}>
                      <span title={accountData.email}>{accountData.email}</span>
                    </div>
                  </div>
                  {/* Preferences Link — Mijn voorkeuren / WIE VOLG IK */}
                  <Link
                    to={routeMap[lang]?.preferences || '/voorkeuren'}
                    className="account_options_item"
                  >
                    <Icon name="Star" />
                    {translate("my_preferences") || "Mijn voorkeuren"}
                  </Link>
                  {/* Account Settings Link */}
                  <Link
                    to={routeMap[lang]?.accountSettings || '/account-instellingen'}
                    className="account_options_item"
                  >
                    <Icon name="Fingerprint" />
                    {translate("account_settings") || "Account beheren"}
                  </Link>
                  {/*
                    <Link to="/saves" className="account_options_item">
                      <Icon name="Magazines" />
                      {translate('saved_cmps')}
                    </Link>
                    <Link to="/following" className="account_options_item">
                      <Icon name="Entrepreneur" />
                      {translate('following_establishments')}
                    </Link>
                  */}
                  {/* <a href="/shoppinglist" target="_blank" className="account_options_item">
                    <Icon name="Eshop" />
                    {translate('shopping_list')}
                  </a> */}
                  <div
                    className="account_options_item"
                    onClick={() => LogoutHandler()}
                  >
                    <Icon name="Logout" />
                    {translate("log_out")}
                  </div>
                </div>
              </div>
            ) : (
              <a
                className="nav_button my_company nav_responsive"
                rel="noreferrer noopener"
                target="_blank"
                onClick={() => dispatch(toggleLoginScreen(!loginScreen))}
              >
                {translate("log_in")}
              </a>
            )}
            {/* Language dropdownmenu */}
            <div className="nav_button drops nav_responsive" id="nav_login">
              {lang.toUpperCase()}
              <div className="lang_options">
                {lang !== "nl" && (
                  <a href={isLocalhost ? `/?lang=nl` : `https://${urlConfig.MIJNSTADGEMEENTE_DOMAIN_URL || 'mijn.stad-gemeente.be'}`}>NL</a>
                )}
                {lang !== "fr" && (
                  <a href={isLocalhost ? `/?lang=fr` : `https://${urlConfig.MAVILLE_DOMAIN_URL || 'ma.ville-commune.be'}`}>FR</a>
                )}
                {lang !== "de" && (
                  <a href={isLocalhost ? `/?lang=de` : `https://${urlConfig.STADTGEMEINDE_DOMAIN_URL || 'meine.stadt-gemeinde.be'}`}>DE</a>
                )}
                {lang !== "en" && (
                  <a href={isLocalhost ? `/?lang=en` : `https://${urlConfig.CITYMUNI_DOMAIN_URL || 'my.city-municipality.be'}`}>EN</a>
                )}
              </div>
              <Icon name="ArrowDown" />
            </div>
          </div>
         </div>
      </div>
    </nav>
  );
};

export default Navigation;
